import styled, { css } from 'styled-components';
import statusSmallIcon_blue from 'static/images/icon/statusSmallIcon_blue.png';
import statusSmallIcon_warning from 'static/images/icon/statusSmallIcon_warning.png';
import statusSmallIcon_danger from 'static/images/icon/statusSmallIcon_danger.png';
import statusSmallIcon_none from 'static/images/icon/statusSmallIcon_none.png';

export const ModuleBox = styled.div`
  display: flex;
  width: 100%;
  min-width: 200px;
  min-height: 115px;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #a7a7a724;
  cursor: pointer;
  padding: 0px 20px 0px 0px;

  &:last-child {
    border-bottom: 0px;
  }

  .moduleStatusImage {
    width: 60px;
    height: 90px;
    flex: 1;
    position: relative;

    img {
      ${props =>
        props.status === 'danger' ? css`content:url(${statusSmallIcon_danger});` :
          (props.status === 'warning' ? css`content:url(${statusSmallIcon_warning});` : 
            (props.status === 'none' ? css`content:url(${statusSmallIcon_none});` : 
                                       css`content:url(${statusSmallIcon_blue});`))
      }
    }
  }

  .moduleInfo {
    flex: 5;
    padding-left: 15px;
    line-height: 1.5;

    .areaInfo {
      font-size: 30px;
    }

    .userAndModuleName {
      font-size: 25px;
      color: #fff;
    }

    .warningTime {
      font-size: 20px;
      
      ${props =>
        props.status === 'danger' ? css`color: #ff0018;` : 
                                    css`color: #E8AD2E;`
      }
    }
  }
`

export const AlertConfirmationChecker = styled.div`
  & > svg {
    color: #fff;
    width: 20px;
    height: 20px;
  }
`